import type React from 'react';
import { floatingActionButtonStyles } from './FloatingActionButton.styles';

interface FloatingActionButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  'aria-label'?: string;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({
  children,
  onClick,
  className,
  disabled,
  'aria-label': ariaLabel,
}) => {
  return (
    <button
      className={`${floatingActionButtonStyles} ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      type="button"
    >
      {children}
    </button>
  );
};

export default FloatingActionButton;
